module.exports = __webpack_public_path__ + "media/images/og-thumbnail-d8ee781dcb64adb9d2d3dc0f89a932e9.png";